let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hLF9k")).then(() => parcelRequire('7xEnC'));